import React from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import CaveatEditor from './CaveatEditor';
import PropTypes from 'prop-types';

class CaveatListEditor extends React.Component {

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.childNodes = {};
  }

  hasChanged() {
    let changed = Object.keys(this.childNodes).find((key) => !this.childNodes[key] || this.childNodes[key].hasChanged());
    return !!changed;
  }

  showParentIndicator() {
    var keys = Object.keys(this.childNodes);
    let active = keys.find((key) => this.childNodes[key].isActive());
    return !!active;
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  render() {
    let props = this.props;
    let caveats = props.domainLogic.caveats[this.props.optionID] || {};
    return (
      <table style={{borderSpacing: 0, width: "100%"}}>
        <tbody>
          {
            props.answers.map((answer) => {
              let caveat = caveats[answer.value || answer.id] || {};
              return <CaveatEditor
                key={"option-" + this.props.optionID + "-answer-" + (answer.value || answer.id || answer.label)}
                answerText={answer.label || answer.title}
                score={caveat.score}
                title={caveat.title}
                onChange={this.onChange}
                ref={(child) => this.childNodes[answer.value || answer.id] = child}
              />
            })
          }
        </tbody>
      </table>
    )
  }

  onChange(value) {
    if(this.props.onUpdate) {
      setTimeout(this.props.onUpdate, 0);
    }
  }

  getValue() {
    let caveats = this.props.domainLogic.caveats[this.props.optionID] || {};
    return this.props.answers.reduce((logic, answer) => {
      if (this.childNodes[answer.value || answer.id].hasChanged()) {
        logic[answer.value || answer.id] = this.childNodes[answer.value || answer.id].getValue();
      }
      if (logic[answer.value || answer.id] && logic[answer.value || answer.id].title === "") {
        delete logic[answer.value || answer.id];
      }
      return logic;
    }, caveats);
  }

}

CaveatListEditor.propTypes = {
  answers: PropTypes.array,
  optionID: PropTypes.number,
  domainLogic: PropTypes.shape({
    caveats: PropTypes.object
  }),
  onUpdate: PropTypes.func
}

export default CaveatListEditor;
